import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SectionContainer } from '../ui/SectionContainer';
import { FAQ_ITEMS } from '../../constants';

interface FAQSectionProps {
  compact?: boolean;
}

/**
 * FAQ section for the Contact page
 * Displays frequently asked questions in an accordion
 */
export const FAQSection: React.FC<FAQSectionProps> = ({ compact = false }) => {
  return (
    <SectionContainer variant="default" compact={compact}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            fontSize: { xs: '1.75rem', md: '2rem' },
          }}
        >
          Frequently Asked Questions
        </Typography>
      </Box>

      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        {FAQ_ITEMS.map((faq, index) => (
          <Accordion
            key={index}
            defaultExpanded={index === 0}
            sx={{
              mb: 2,
              borderRadius: 2,
              '&:before': { display: 'none' },
              backgroundColor: (theme) =>
                theme.palette.mode === 'light' ? '#FFFFFF' : 'rgba(255, 255, 255, 0.05)',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
              '&:first-of-type': { borderRadius: 2 },
              '&:last-of-type': { borderRadius: 2 },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                '& .MuiAccordionSummary-content': {
                  my: 2,
                },
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </SectionContainer>
  );
};
